// /join/<CODE>[?src=qr]: the school join landing (feature 003; P-JOIN-2 to P-JOIN-7).
import { JoinLandingScreen } from "@/join/JoinLandingScreen";

export default function Join() {
  return <JoinLandingScreen />;
}
